import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
import { Eyebrow, SectionTitle } from './ui/Section';
export function Bonuses() {
  return <section className="bg-canvas px-4 py-12 md:py-14" data-id="element-19" data-mp="avcvgfktva6b">
      <div className="mx-auto max-w-6xl" data-id="element-20" data-mp="autg96mkazvz">
        <Eyebrow data-id="element-21" data-mp="ftwi6i78wpzq">
          <span className="inline-flex items-center gap-2" data-id="element-22" data-mp="ftej7dt77xo4">
            <GiftIcon className="h-4 w-4" data-id="element-23" data-mp="1uerfxae32nq" /> 5 bonos siempre incluidos
          </span>
        </Eyebrow>
        <SectionTitle data-id="element-24" data-mp="5w0do98tctal">
          Además te llevás <span className="text-accent" data-id="element-25" data-mp="5x1lm4uj8zo3">5 bonos gratis</span>
        </SectionTitle>
        <div className="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-26" data-mp="3o2eohzbscn4r">
          {bonuses.map(bonus => <article key={bonus.number} className={`flex flex-col rounded-2xl border bg-white p-5 shadow-sm ${bonus.featured ? 'border-2 border-accent' : 'border-line'}`} data-id="element-27" data-mp="3t1rayiyqvs6t">
              <div className="flex gap-3" data-id="element-28" data-mp="1r80gg0kv90al">
                <span className="text-3xl leading-none" data-id="element-29" data-mp="3ieg9h9e6kh3h">{bonus.icon}</span>
                <div data-id="element-30" data-mp="3iclj3fk53ws0">
                  <small className="font-extrabold uppercase tracking-wide text-accent-dark" data-id="element-31" data-mp="3dfd2vkijy2te">
                    Bono {bonus.number}
                  </small>
                  <h3 className="text-base font-black uppercase leading-tight text-ink" data-id="element-32" data-mp="3r68f96s9f21q">
                    {bonus.name}
                  </h3>
                </div>
              </div>
              <p className="mt-4 text-sm font-semibold leading-relaxed text-slate-600" data-id="element-33" data-mp="2zgltucijr7c4">
                {bonus.description}
              </p>
              <ul className="my-4 flex-1 space-y-1.5 text-sm font-semibold leading-snug text-slate-600" data-id="element-34" data-mp="2uitzlbufj94r">
                {bonus.items.map(item => <li key={item} className="flex gap-2" data-id="element-35" data-mp="33g49asrlmq7k">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" data-id="element-36" data-mp="nq198tmdgsps" />
                    {item}
                  </li>)}
              </ul>
              <div className="mt-auto flex items-center border-t border-line pt-4 text-sm font-extrabold" data-id="element-37" data-mp="iqoqajymg5sh">
                <span className="text-slate-400 line-through" data-id="element-38" data-mp="3cl0tj379mahb">{bonus.value} valor</span>
                <span className="ml-auto rounded-full bg-accent px-3 py-1 text-white" data-id="element-39" data-mp="3hg6d3vd73d28">
                  GRATIS HOY
                </span>
              </div>
            </article>)}
        </div>
        <p className="mt-7 text-center text-base font-bold text-slate-600 md:text-lg" data-id="element-40" data-mp="3qhwf1v4pdue9">
          Valor total de bonos: <s className="text-slate-400" data-id="element-41" data-mp="2tqc3rns346mq">$58.950 ARS</s> →{' '}
          <span className="font-black text-accent" data-id="element-42" data-mp="2xv1uky7vyv0s">incluidos gratis hoy</span>
        </p>
      </div>
    </section>;
}